import { ENDPOINTS } from '../../network/endpoints';

/** @implements {import('../../../contracts/IVoicesRepository').IVoicesRepository} */
export class VoicesRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async getVoices(options = {}) {
    const response = await this.client.get(ENDPOINTS.VOICES.BASE, {
      params: options,
    });
    return response.voices || response;
  }

  async getVoiceById(voiceId) {
    return this.client.get(ENDPOINTS.VOICES.BY_ID(voiceId));
  }

  async deleteVoice(voiceId) {
    return this.client.delete(ENDPOINTS.VOICES.BY_ID(voiceId));
  }

  async findSimilarVoices(request) {
    return this.client.post(ENDPOINTS.VOICES.SIMILAR, request);
  }

  async editVoice(voiceId, voiceData) {
    return this.client.post(ENDPOINTS.VOICES.EDIT(voiceId), voiceData);
  }
}
